import React from 'react';
import { motion } from 'framer-motion';
import './CommunitySection.css';

const CommunitySection = () => {
  const stats = [
    {
      number: "1,000+",
      label: "Students Coached",
      color: "purple"
    },
    {
      number: "50+",
      label: "Expert Coaches",
      color: "orange"
    },
    {
      number: "4.9/5",
      label: "Average Rating",
      color: "purple"
    }
  ];

  const testimonial = {
    quote: "Working with my Creedom coach has completely transformed my confidence and vocal ability. I've gone from singing in my bedroom to performing at local venues!",
    author: "Sarah M."
  };

  return (
    <section id="community" className="community-section">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="community-card"
        >
          {/* Header */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
            className="community-header"
          >
            <h2>
              Join the <span className="highlight">Creedom</span> Community
            </h2>
          </motion.div>

          {/* Statistics */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
            className="stats-grid"
          >
            {stats.map((stat, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: 0.6 + index * 0.2 }}
                viewport={{ once: true }}
                className="stat-item"
              >
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.8 + index * 0.2 }}
                  viewport={{ once: true }}
                  className={`stat-number ${stat.color}`}
                >
                  {stat.number}
                </motion.div>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 1 + index * 0.2 }}
                  viewport={{ once: true }}
                  className="stat-label"
                >
                  {stat.label}
                </motion.div>
              </motion.div>
            ))}
          </motion.div>

          {/* Testimonial */}
          {/* <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1.2 }}
            viewport={{ once: true }}
            className="testimonial"
          >
            <motion.blockquote
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 1.4 }}
              viewport={{ once: true }}
              className="testimonial-quote"
            >
              "{testimonial.quote}"
            </motion.blockquote>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 1.6 }}
              viewport={{ once: true }}
              className="testimonial-author"
            >
              - {testimonial.author}
            </motion.div>
          </motion.div> */}
        </motion.div>
      </div>
    </section>
  );
};

export default CommunitySection;
